import {Component, Input, OnInit} from '@angular/core';
import {ProvinceDTO} from '../../../../shared/dto/province.model';
import {DistrictDTO} from '../../../../shared/dto/district.model';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ProvinceService} from '../../../../shared/service/province.service';
import {DistrictService} from '../../../../shared/service/district.service';
import {DistrictComponent} from '../district.component';
import {ActionMode} from '../../../../shared/enums/action-mode.enum';
import swal from "sweetalert2";
import {DistrictPopupComponent} from '../district-popup/district-popup.component';

@Component({
  selector: 'app-district-search-table',
  templateUrl: './district-search-table.component.html',
  styleUrls: ['./district-search-table.component.scss']
})
export class DistrictSearchTableComponent implements OnInit {
  @Input() items: DistrictDTO[];
  @Input() index: number;
  @Input() page: number=1;
  @Input() itemsPerPage: number=5;
  private provinceDTOS: ProvinceDTO [] = [];
  private districtDTOS: DistrictDTO [] = [];

  constructor( public modalService: NgbModal,
               private districtMgt: DistrictComponent,
               private provinceService: ProvinceService,
               private districtService: DistrictService) { }

  ngOnInit() {
    this.loadDistricts();
  }

  loadDistricts() {
    this.districtService.getAllDistricts().subscribe(
      (data: DistrictDTO []) => {
        this.districtDTOS = data;
      }
    );
  }

  onClickUpdate(Item){
    const modalRef = this.modalService.open(DistrictPopupComponent, {
      windowClass: "xlModal"
    });
    modalRef.componentInstance.name = "Update District Details";
    modalRef.componentInstance.code =  Item.districtCode;
    modalRef.componentInstance.description = Item.description;
    modalRef.componentInstance.selectedState = Item.status;
    modalRef.componentInstance.province = Item.province;
    modalRef.componentInstance.provinceMgtCopy_ = Item;
    modalRef.componentInstance.selectedMode = ActionMode.UPDATE;
    modalRef.result.then(
      (data: string) => {
        if (data == "Saved") {
          this.districtMgt.onLoadGetData();
        }
      },
      () => { }
    );
  }

  onDelete(Item) {
    swal.fire({
      title: "Are you sure, you want to delete?",
      text: "",
      showCancelButton: true,

      confirmButtonText: "Yes"
    }).then(
      (result) => {
        if(result.value) {
          this.districtService.deleteDistrictDetails(Item.districtCode).subscribe(
            (res: boolean) => {
              if (res === true) {
                swal.fire("Success", "Details Deleted successfully", "success");
                this.items.splice(Item, 1);
                this.loadDistricts();
              } else if (res === false) {
                swal.fire("Sorry!", "Details can't be deleted...!", "error");
              }
            },
            (error) => {
              console.log(error);
              swal.fire("Sorry!", "Something went wrong...!", "error");
            },
            () => {
              this.loadDistricts();
            }
          );
        }
      }, reason => {
      }
    );
  }

  onClickView(Item){
    const modalRef = this.modalService.open(DistrictPopupComponent, {
      windowClass: "xlModal"
    });
    modalRef.componentInstance.name = "View District Details";
    modalRef.componentInstance.code =  Item.districtCode;
    modalRef.componentInstance.description = Item.description;
    modalRef.componentInstance.selectedState = Item.status;
    modalRef.componentInstance.province = Item.province;
    modalRef.componentInstance.provinceMgtCopy_ = Item;
    modalRef.componentInstance.selectedMode = ActionMode.VIEW;
  }

}
